import {FC, ReactNode, useContext, useEffect, useState} from 'react';
import {alertContext} from '../contextApi/context/error';
import {Alert} from '@mui/material';

interface AlertContainerProps {
  children: ReactNode;
}

const short = 3000;
const long = 10000; // 10 segundos para errores y warnings
export const AlertContainer: FC<AlertContainerProps> = ({children}) => {
  const {
    state: {config, showing},
    dispatch,
  } = useContext(alertContext);
  const [countdown, setCountdown] = useState<number>(0);

  useEffect(() => {
    if (config?.duration && !config.cancelable) {
      let duration;
      if (config.duration === 'short') {
        duration = short;
      } else if (config?.duration === 'long') {
        duration = long;
      } else {
        duration = config.duration;
      }

      // Inicializar contador en segundos
      setCountdown(Math.ceil(duration / 1000));

      // Temporizador para cerrar el mensaje
      const dismissTimer = setTimeout(() => {
        config?.callback && config.callback();
        dispatch({type: 'dismiss', payload: null});
      }, duration);

      // Temporizador para actualizar el contador cada segundo
      const countdownInterval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearTimeout(dismissTimer);
        clearInterval(countdownInterval);
      };
    }
  }, [config, dispatch]);

  return (
    <>
      {showing && (
        <Alert className="absolute w-4/5" severity={config?.level || undefined}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <span>{config?.message}</span>
            {!config?.cancelable && countdown > 0 && (
              <span
                style={{
                  fontSize: '0.75rem',
                  opacity: 0.7,
                  marginLeft: '1rem',
                  fontWeight: 'bold',
                  minWidth: '2rem',
                  textAlign: 'right',
                }}
              >
                {countdown}s
              </span>
            )}
          </div>
        </Alert>
      )}
      {children}
    </>
  );
};
